import { flatEntry } from "./FlatTable";

import "./listStyles.scss";

// Labelled list of plain values, used where the interactive widget is a
// sidebar master/detail pane (IOCs, Android additional details): only one
// section is mounted there, so a capture of the live widget would miss the
// rest. This prints one section per call and every section gets rendered.
const FlatList = ({ title, items, maxRows, moreLabel = "entries" }) => {
  const rows = Array.isArray(items) ? items : [];

  const visibleRows = maxRows ? rows.slice(0, maxRows) : rows;
  const hiddenCount = rows.length - visibleRows.length;

  return (
    <div className="flat-list">
      <h3 className="flat-list__title">
        {title} ({rows.length})
      </h3>

      {rows.length === 0 ? (
        <p className="flat-list__empty">No data</p>
      ) : (
        visibleRows.map((item, index) => (
          <p className="flat-list__row" key={index}>
            {flatEntry(item)}
          </p>
        ))
      )}

      {hiddenCount > 0 ? (
        <p className="flat-list__more">
          +{hiddenCount} more {moreLabel} — see the CSV export for the full list
        </p>
      ) : null}
    </div>
  );
};

export default FlatList;
